import { Component, Inject } from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    template: `
    <h1 mat-dialog-title [innerHTML]="this.title">Statement</h1>
    <div mat-dialog-content [innerHTML]="this.html"> 
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)='closeDialog()'  tabindex="2">Ok</button>
    </div>
    `
  })
  export class DialogComponent {
    html: string;
    title: string;
    constructor(
      public dialogRef: MatDialogRef<DialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) { }
  
    closeDialog(): void {
      this.dialogRef.close();
    }
  
}


// WEBPACK FOOTER //
// ./src/app/shared/components/dialog/dialog.component.ts